import { IGroupSpaceResource } from "../../group-spaces";
import { IUserResource } from "../../users";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { GroupTaskStatus, IGroupTaskList } from "../types";

export interface IGroupTaskListQueryParameters extends IPaginateable, IOrderable<"rank" | "title"> {
    filters?: {
        groupSpace?: RelationalFilter<IGroupSpaceResource>;
        learner?: RelationalFilter<IUserResource>;
        status?: GroupTaskStatus;
    };
}

export type IGroupTaskListQueryResult = IGroupTaskList;

const mapFilters = (filters: IGroupTaskListQueryParameters["filters"]) => {
    const { groupSpace, learner, status } = filters ?? {};
    return {
        status,
        "groupSpace.uuid": mapRelationalFilter(groupSpace),
        "learner.uuid": mapRelationalFilter(learner),
    };
};

export const groupTaskListQuery: IApiQueryFunction<IGroupTaskListQueryParameters> = ({
    filters,
    order,
    pagination,
}) => {
    return {
        method: "GET",
        url: `/group_tasks${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useGroupTaskListQuery = createApiQueryHook<IGroupTaskListQueryParameters, IGroupTaskListQueryResult>(
    groupTaskListQuery,
);
